import styled from '@mui/material/styles/styled';

export const Canvas = styled('canvas')({
  width: 160, 
  maxWidth: 160,
  height: 64, 
  borderRadius: '8px', 
  padding: 12, 
  fontWeight: 700
});